import React from 'react';
import { CalendarHeaderProps } from '../types/Calendar.types';
import { NavigationButton } from '../atoms/NavigationButton';
import { InnerButton } from '@/modules/InnerButton';
import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentDate,
  viewMode,
  onNavigate,
  onToggleViewMode,
  onGoToToday,
  monthNames = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  className = '',
  renderHeader,
}) => {
  const getHeaderText = () => {
    switch (viewMode) {
      case 'days':
        return `${monthNames[currentDate.getMonth()].slice(0, 3)}, ${currentDate.getFullYear()}`;
      case 'months':
        return currentDate.getFullYear().toString();
      case 'years':
        const year = currentDate.getFullYear();
        return `${year - 5} - ${year + 6}`;
      default:
        return '';
    }
  };

  const handleToggleViewMode = () => {
    onToggleViewMode();
  };

  if (renderHeader) {
    return renderHeader({
      currentDate,
      viewMode,
      toggleViewMode: handleToggleViewMode,
      navigate: onNavigate,
    });
  }

  return (
    <div className={`ui-flex ui-flex-col ui-border-b ui-border-default ${className}`}>
      {/* Header principal con navegación */}
      <div className="ui-flex ui-items-center ui-justify-between ui-px-4 ui-py-3">
        {onGoToToday && (
          <InnerButton
            onClick={onGoToToday}
            theme="solid"
            size="xxs"
            color="secondary"
            pill="xs"
            aria-label="Ir a la fecha de hoy"
          >
            Hoy
          </InnerButton>
        )}
        <InnerButton
          onClick={handleToggleViewMode}
          size="xxs"
          pill="xs"
          color="tertiary"
          rightSlot={faAngleDown}
          aria-label={`Cambiar vista a ${viewMode === 'days' ? 'meses' : viewMode === 'months' ? 'años' : 'días'}`}
        >
          {getHeaderText()}
        </InnerButton>
        <div className="ui-flex ui-items-center ui-gap-1">
          <NavigationButton direction="prev" onClick={() => onNavigate('prev')} />
          <NavigationButton direction="next" onClick={() => onNavigate('next')} />
        </div>
      </div>
    </div>
  );
};
